import React from 'react';

import ResponsiveTableV2 from '../../../..';

const ResponsiveSubTable: React.FC<any> = (props) => {
  const { data } = (props as unknown) as any;
  return (
    <div style={{ height: 150, width: '100%' }}>
      <ResponsiveTableV2 {...data} />
    </div>
  );
};

export default ResponsiveSubTable;
